/**
 * DataTableオプション
 */
export class DataTableOptions {
    /* ページ */
    page = 1
    /* １ページの表示件数 */
    itemsPerPage = 50
    /* データ件数 */
    itemsLength = 0

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<DataTableOptions>) {
        Object.assign(this, init)
    }
}
